import React, { useState } from "react";
import { Box, Divider, Stack, Typography } from "digiwash-components";
import { Platform, Linking, Alert } from "react-native";

import useProfile from "../ducks/user/hooks/useProfile";
import ProfileInfo from "../containers/ProfileInfo";
import CreditInfo from "../containers/CreditInfo";
import { CreditContext } from "../contexts/credit";
import ModalAddCredit from "../components/ModalAddCredit";
import PageContainer from "../components/PageContainer";
import styled from "styled-components/native";
import { useDispatch } from "react-redux";
import globalActions from "../ducks/global/actions";
import { persistor } from "../configs/store-config";
import { COMPANY_PHONE } from "../configs/constants-config";
import useNavigation from "../hooks/useNavigation";
import { Helmet } from "react-helmet";
import SectionList from "../containers/SectionList";
import Loading from "../components/Loading";

import { useListenToDeepLinks } from "../hooks/useListenToDeepLinks";

const ProfileShape = styled(Box)`
  height: 177;
  position: absolute;
  width: 100%;
  border-bottom-right-radius: 24px;
  border-bottom-left-radius: 24px;
`;

let myDigiwashList = [
  {
    title: "آدرس ها",
    icon: "location",
    action: "addressesList",
  },
  {
    title: "لیست تراکنش ها",
    icon: "payment",
    action: "transactionsList",
  },
  // {
  //   title: "شخصی سازی",
  //   icon: "personal",
  //   action: "personalization",
  // },
];
let commonList = [
  { title: "تماس با پشتیبانی", icon: "call", action: "support" },
  { title: "سوالات متداول", icon: "info", action: "questions" },
  {
    title: "نسخه اپلیکیشن",
    icon: "appVersion",
    action: "appInfo",
    hide: Platform.OS === "android" ? false : true,
  },
  { title: "قوانین و مقررات", icon: "terms", action: "terms" },
];
let logOut = [
  {
    title: "خروج از حساب کاربری",
    icon: "logOut",
    action: "logOut",
    iconColor: "red.main",
    textColor: "red.main",
  },
];

// TODO: It doesn't have same api in web.

function ProfilePage() {
  let [isCreditModalOpen, setCreditModalOpen] = useState(false);
  let dispatch = useDispatch();
  let { data, isValidating } = useProfile();
  let nav = useNavigation();
  let [meta, setMeta] = useState({});
  useListenToDeepLinks();

  const confirmationAlert = () => {
    if (Platform.OS === "web") {
      let confirmed = confirm("آیا برای خروج از حساب کاربری مطمئن هستید؟");
      if (confirmed) {
        dispatch(globalActions.logout());
        persistor.flush();
        nav.navigate("Home");
        if (window.Raychat) {
          window.Raychat.unloadUser();
        }
      }
    } else {
      Alert.alert(
        "خروج از حساب کاربری",
        "آیا برای خروج از حساب کاربری مطمئن هستید؟",
        [
          {
            text: "انصراف",
            style: "cancel",
          },
          {
            text: "بله",
            onPress: () => {
              dispatch(globalActions.logout());
              persistor.flush();
              nav.navigate("Home");
              if (window.Raychat) {
                window.Raychat.unloadUser();
              }
            },
          },
        ],
        { cancelable: false }
      );
    }
  };

  return (
    <CreditContext.Provider
      value={{
        isCreditModalOpen,
        setCreditModalOpen: (value, meta) => {
          setCreditModalOpen(value);
          setMeta(meta);
        },
        meta,
      }}
    >
      <Helmet>
        <title>پروفایل | دیجی واش</title>
      </Helmet>
      <PageContainer
        extraSpaceFromBottom
        showBottomNavigation
        bg="common.white"
        afterScrollView={
          <>
            <ModalAddCredit />
          </>
        }
        insideBeignScrollView={
          <>
            <ProfileShape bg="primary.main"></ProfileShape>
            <ProfileInfo data={data} />
            <CreditInfo data={data} />
            <Divider size="xxxl" />
            {isValidating ? <Loading color="primary.main" /> : null}
            {!isValidating && data ? (
              <Stack distribution="center">
                <Box
                  p="l"
                  style={{
                    maxWidth: 768,
                    margin: "auto",
                    width: "100%",
                  }}
                >
                  <Typography color="common.black" ff="mainBold" fs="l">
                    دیجی واش من
                  </Typography>
                  <Divider size="l" />
                  <SectionList
                    data={myDigiwashList}
                    onSubmit={(item) => {
                      if (item.action === "addressesList") {
                        nav.navigate("UserAddresses");
                      } else if (item.action === "transactionsList") {
                        nav.navigate("UserTransactions");
                      } else if (item.action === "personalization") {
                        nav.navigate("Personalization");
                      }
                    }}
                  />
                  <Divider size="xxxl" />
                  <SectionList
                    data={commonList}
                    onSubmit={(item) => {
                      if (item.action === "support") {
                        let phoneNumber;
                        if (Platform.OS === "ios") {
                          phoneNumber = `telprompt:${COMPANY_PHONE}`;
                        } else {
                          phoneNumber = `tel:${COMPANY_PHONE}`;
                        }

                        Linking.openURL(phoneNumber);
                      } else if (item.action === "terms") {
                        Linking.openURL(
                          "https://digiwash.ir/%d9%82%d9%88%d8%a7%d9%86%db%8c%d9%86-%d9%88-%d9%85%d9%82%d8%b1%d8%b1%d8%a7%d8%aa/"
                        );
                      } else if (item.action === "questions") {
                        Linking.openURL(
                          "https://digiwash.ir/%d8%b3%d9%88%d8%a7%d9%84%d8%a7%d8%aa-%d9%85%d8%aa%d8%af%d8%a7%d9%88%d9%84/"
                        );
                      } else if (item.action === "appInfo") {
                        nav.navigate("AppInfo");
                      }
                    }}
                  />
                  <Divider size="xxxl" />
                  <SectionList
                    data={logOut}
                    onSubmit={(item) => {
                      if (item.action === "logOut") {
                        confirmationAlert();
                      }
                    }}
                  />
                  <Divider size="huge" />
                </Box>
              </Stack>
            ) : null}
          </>
        }
      />
    </CreditContext.Provider>
  );
}

export default ProfilePage;
